import React from 'react';
import cn from 'classnames';

import {ITopBannerV3} from './ITopBannerV3';

import styles from './TopBannerV3.module.scss';

const TopBannerV3 = ({body}: ITopBannerV3) => {
	return (
		<div className={cn(styles['module__top-banner__v3'], 'top-banner__v3')}>
			{body.length && <div className={styles['module__top-banner__v3__wrapper']}>{body[0]}</div>}
			{body.length > 1 && <div className={styles['module__top-banner__v3__wrapper']}>{body[1]}</div>}
		</div>
	);
};

export default TopBannerV3;
